import { useEffect, useState } from "react";

import {
  clearNodesFromLocalStorage,
  clearSelectedBrandOrderLocalStorage,
} from "../utils/localStorage";

import { useSelfServeContextStore } from "./SelfServeContext";

/**
 * When the root path or the select-topic path is loaded for the 1st time
 * we don't want the user to be taken to other steps because nodes were found
 * in the local storage. This was caused by the effect that redirected to next step
 * when the level 1 node was not undefined. nodesClearedAtInitialLoad is returned so that
 * SelectTopic can prevent an early redirection to next step before the local storage is cleared
 */
export const useClearNodesInLocalStorageOnLoad = () => {
  const [nodesClearedAtInitialLoad, setNodesClearedAtInitialLoad] =
    useState(false);
  const [, setSelfServeContextStore] = useSelfServeContextStore([
    "selectedBrandOrder",
  ]);
  useEffect(() => {
    if (!nodesClearedAtInitialLoad) {
      clearNodesFromLocalStorage();
      clearSelectedBrandOrderLocalStorage();
      setSelfServeContextStore({ selectedBrandOrder: undefined });
      setNodesClearedAtInitialLoad(true);
    }
  }, [nodesClearedAtInitialLoad, setSelfServeContextStore]);
  return { nodesClearedAtInitialLoad };
};
